<!-- eslint-disable vue/valid-v-model -->
<template>
  <div
    v-if="modal"
    class="overlay"
  >
    <div
      v-model="modal"
      class="wrapper"
    >
      <p
        v-if="title"
        class="headline grey lighten-2"
        primaryTitle
      >
        {{ title }}
      </p>
      <p
        v-else
        class="headline grey lighten-2"
      ></p>
      <div
        v-if="navIcons.length"
        class="nav-icons-wrapper"
      >
        <div
          v-for="icon in navIcons"
          :key="icon.id"
          :class="['nav-icon',
                   hasSelected && icon.id === selectedNavIcon.id && 'nav-icon-selected',
                   icon.isUsed && 'nav-icon-used']"
          @click="selectNavIcon(icon)"
        >
          <img
            class="nav-icon-img"
            :src="icon.url"
            alt="image"
          />
          <inline-svg
            v-if="icon.isUsed"
            :src="iconSelected"
            class="svg-icon used-icon"
          >
          </inline-svg>
        </div>
      </div>
      <div class="button-wrapper">
        <Button
          v-if="isNeedCancel"
          :title="cancelButtonTitle"
          :classType="isOrangeCancel && isNeedToApply
            ? 'warning'
            : !isNeedToApply
              ? 'primary'
              : 'warning'"
          :eventFunction="closeModalhandler"
        />
        <Button
          v-if="isNeedToApply"
          :title="confirmButtonTitle"
          :classType="'primary'"
          :eventFunction="acceptHandler"
          :disabled="!selectedNavIcon"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import {
  SET_OVERFLOW,
} from '../../store/actions/common';
import Button from './Button.vue';
import iconWarning from '../../assets/icons/icon-warning-localization.svg';
import iconNewWindow from '../../assets/icons/icon-new-window.svg';
import iconSelected from '../../assets/icons/icon-nav-icon-selected.svg';
import { GET_VAE_ICONS_REQUEST } from '../../store/actions/cmsActions/cmsActions';

export default {
  name: 'NavigationIconsModal',
  components: {
    Button,
  },
  props: {
    modal: Boolean,
    title: {
      type: String,
      default: '',
    },
    bodyMessage: {
      type: String,
      default: '',
    },
    bodyHelfullMessage: {
      type: String,
      default: '',
    },
    onAccept: {
      type: Function,
      default: () => {},
      required: false,
    },
    onDecline: {
      type: Function,
      default: () => {},
      required: false,
    },
    onClose: {
      type: Function,
      default: () => {},
      required: false,
    },
    confirmButtonTitle: {
      type: String,
      default: 'Add',
    },
    cancelButtonTitle: {
      type: String,
      default: 'Cancel',
    },
    futureStandaloneEvents: {
      type: Array,
      default: () => [],
      required: false,
    },
    fallbackMedia: {
      type: Object,
      default: null,
      required: false,
    },
    notRecurringMediaItem: {
      type: Array,
      default: () => [],
      required: false,
    },
    recurringMediaItem: {
      type: Array,
      default: () => [],
      required: false,
    },
    isCombiningDeletion: {
      type: Boolean,
      default: false,
    },
    isNeedCancel: {
      type: Boolean,
      default: true,
    },
    isWarning: {
      type: Boolean,
      default: false,
    },
    isDeleteAcc: {
      type: Boolean,
      default: false,
    },
    isOrangeCancel: {
      type: Boolean,
      default: false,
    },
    isInUseAsset: {
      type: Boolean,
      default: false,
    },
    warningMess: {
      type: String,
      default: '',
    },
    isNeedToApply: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      iconWarning,
      iconNewWindow,
      iconSelected,
      navIcons: [],
      selectedNavIcon: null,
      hasSelected: false,
    };
  },
  computed: {
    ...mapGetters([
      'getCurrentAccountId',
      'getCurrentAccount',
    ]),
    ...mapState({
      isLoading: (state) => state.cms.isLoading,
      isEditedForm: (state) => state.common.isEditedForm,
    }),
  },
  created() {
    const params = {
      accountId: this.getCurrentAccountId,
    };
    this.$store.dispatch(GET_VAE_ICONS_REQUEST, params).then((res) => {
      this.navIcons = res.data;
    });
  },
  methods: {
    closeModal() {
      if (this.onClose) {
        this.onClose();
        return;
      }
      this.$emit('input', false);
      this.$store.dispatch(SET_OVERFLOW, false);
    },
    accept() {
      this.onAccept(this.selectedNavIcon);
      if (!this.isWarning) {
        this.closeModal();
      }
    },
    closeModalhandler() {
      this.onDecline();
      this.closeModal();
    },
    acceptHandler() {
      this.accept();
    },
    selectNavIcon(icon) {
      this.hasSelected = true;
      this.selectedNavIcon = icon;
    },
  },
};
</script>

<style scoped>
.overlay {
  background-color: rgba(0, 0, 0, 0.5);
  bottom: 0;
  height: 100vh;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 10;
}

.wrapper {
  background-color: #222222;
  border-radius: 4px;
  display: block;
  left: 50%;
  max-width: 100%;
  outline: none;
  overflow-wrap: break-word;
  position: absolute;
  text-decoration: none;
  top: 49%;
  transform: translate(-50%, -50%);
  padding: 30px;
  padding-right: 10px;
  width: 562px;
}

.headline {
  color: #fff;
}

.headline {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  margin: 0;
  padding-bottom: 15px;
  word-break: break-all;
}

.button-wrapper {
  align-items: center;
  display: flex;
  justify-content: flex-end;
  padding-top: 15px;
  margin-right: 20px;
}

.button-wrapper button:first-child {
  margin-right: 15px;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

li {
  padding-left: 1em;
  text-indent: -.7em;
  padding-bottom: 15px;
}

li::before {
  content: "• ";
  color: var(--darkgray);
}

a {
  text-decoration: none;
  color: #2591CF;
}

.nav-icon {
  width: 90px;
  height: 90px;
  border: 1px solid #4C5057;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  margin-right: 20px;
  cursor: pointer;
  position: relative;
}

.nav-icon:hover {
  border-color: #2591CF;
}

.nav-icon-selected {
  border: 2px solid #2591CF;
}

.nav-icon-img {
  width: 50%;
  height: 50%;
  object-fit: contain;
}

.nav-icons-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.nav-icon-used {
  background-color: #4C5057;
}

.used-icon {
  position: absolute;
  bottom: 2px;
  right: 5px;
}
</style>
